import I18n from 'i18n-js';
import React, { Component } from 'react';
import { func, shape } from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { logout as logoutAction } from '../../auth/actions/auth';
import { ROUTE_HOME, ROUTE_PROFILE } from '../../../routes';
import defaultUser from '../../../assets/images/defaultUser.svg';

class Header extends Component {
  static propTypes = {
    profile: shape().isRequired,
    logout: func.isRequired,
  };

  state = {
    displayProfileDropdown: false,
  };

  constructor() {
    super();

    this.toggleProfileDropdown = this.toggleProfileDropdown.bind(this);
  }

  toggleProfileDropdown() {
    this.setState({ displayProfileDropdown: !this.state.displayProfileDropdown });
  }

  /**
   * {@inheritdoc}
   */
  render() {
    const { displayProfileDropdown } = this.state;
    const { profile } = this.props;
    const dropdownClasses = classnames('dropdown', {
      'dropdown--expand': displayProfileDropdown,
    });

    return (
      <div className="header">
        <Link to={ROUTE_HOME} className="logo">
          Un temps
          <span> pour un autre</span>
        </Link>
        <div onClick={this.toggleProfileDropdown} className={dropdownClasses}>
          <span className="dropdown__toggle">
            <span className="user-picture">
              <span className="user-picture__image user-picture__image--small" style={{ backgroundImage: `url(${profile.avatar || defaultUser})` }}></span>
            </span>
            <span>{`${profile.firstname} ${profile.lastname}`}</span>
            <span className="chevron"></span>
          </span>
          <div className="dropdown__menu">
            <Link className="link" to={ROUTE_PROFILE}>Mon profil</Link>
            <button className="link" onClick={this.props.logout}>{I18n.t('common.logout')}</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile.me,
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logoutAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);



// WEBPACK FOOTER //
// ./src/modules/common/components/Header.js